class PlaceholderShownPolyfill {
	constructor() {
		const self = this;
		document.querySelectorAll("[placeholder]").forEach(function(el) {
			if (el.getAttribute("placeholder") !== "")
				self.updatePlaceholder.call(el);

			el.addEventListener("change", self.updatePlaceholder);
			el.addEventListener("keyup", self.updatePlaceholder);
		});
	}

	updatePlaceholder() {
		this.classList[this.value ? "remove" : "add"]("placeholder-shown");
	}
}

if (/^[c|i]|d$/.test(document.readyState || "")) {
	new PlaceholderShownPolyfill();
} else {
	document.addEventListener(
		"DOMContentLoaded",
		() => new PlaceholderShownPolyfill()
	);
}
